import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'typeface-roboto/index.css'

import Vue from 'vue'
import App from './App.vue'

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

// Sentry.init({
//     dsn: 'https://8c82c6df42304f67978e50b4aa14a2a5@sentry.io/1495818',
//     integrations: [new Integrations.Vue({Vue, attachProps: true})],
// });

Vue.config.productionTip = false

import Vuetify from 'vuetify'
import router from './router'
import store from './store'
import * as axios from 'axios'
import {Howl, Howler} from 'howler'

import 'vuetify/src/stylus/main.styl' // Ensure you are using stylus-loader

import en from './lang/en'
import cs from './lang/cs'

const apollo = createProvider()

store.$axios = axios
store.$apollo = apollo.clients.defaultClient

Vue.use(Vuetify, {
    theme: {
        primary: '#F2A200',
        'primary--text': '#000000'
    },
    iconfont: 'md',
    lang: {
        locales: { en, cs },
        current: store.state.settings.lang
    }
})

import VueOffline from 'vue-offline'
Vue.use(VueOffline)

import moment from 'vue-moment'
Vue.use(moment)

Vue.component('router-link', Vue.options.components.RouterLink);
Vue.component('router-view', Vue.options.components.RouterView);

import { createProvider } from './vue-apollo'
import './registerServiceWorker'

new Vue({
    router,
    store,
    apolloProvider: createProvider(),
    render: h => h(App)
}).$mount('#app')
